import {SvgIcon} from '@mui/material';
import React from 'react';
import XLogo from '../../../assets/icons/x-logo.jsx';

const XIcon = props => (
  <SvgIcon {...props}>
    <XLogo />
  </SvgIcon>
);

export default XIcon;
